import imageCompression from 'browser-image-compression';
//获取uuid
export const getUuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
//金额格式
export const amountFormatter = (val) => {
  if (val) {
    const parts = val.toString().split("."); // 分离整数和小数部分
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? "." + parts[1] : "";

    // 使用正则表达式在整数部分添加逗号
    // \\B 匹配非单词边界，(?=(\\d{3})+(?!\\d)) 是一个零宽断言，匹配后面跟着3个数字且后面没有数字的位置
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return formattedInteger + decimalPart;
  } else {
    return 0;
  }
};
//数字加密
export const maskNumber = (num) => {
  if (num) {
    let str = num.toString();
    // 替换前两位和后两位为*
    let maskedStr = str.substring(0, 4) + "***" + str.substring(num.length - 4);
    return maskedStr;
  }
};
//身份证时间格式
export const formatIdCardDate = (dateStr) => {
  // 将身份证中的日期（如19900101）转为YYYY-MM-DD格式
  if (dateStr && dateStr.length === 16) {
    return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)} ~ ${dateStr.slice(8, 12)}-${dateStr.slice(12, 14)}-${dateStr.slice(14, 16)}`;
  }
  return dateStr;
};
//数组对象去重
/**
 * 
 * @param {*} arr 数组
 * @param {*} key 去重的key
 * @returns 
 *  用法：const result = uniqueById(data, 'id');
 */
export const uniqueById = (arr, key) => {
  const uniqueArr = arr.reduce((acc, curr) => {
    if (!acc.find(item => item[key] === curr[key])) {
      acc.push(curr);
    }
    return acc;
  }, []);
  return uniqueArr;
};
//银行卡号格式化
export const formatBankCard = (bankCard) => {
  if (bankCard) {
    return bankCard.replace(/\d{4}/g, "$& ");
  }
  return "";
}
//银行卡掩码规则 **** 9834
export const maskBankCard = (bankCard) => {
  if (!bankCard) return "";
  const digits = String(bankCard).replace(/\s+/g, "");
  const last4 = digits.slice(-4);
  return digits.length > 4 ? `**** ${last4}` : last4;
}
//身份证号格式化
export const formatIdCard = (idCard) => {
  if (idCard) {
    return idCard.replace(/\d{4}/g, "$& ");
  }
  return "";
}
  /**
   * 压缩图片
   * @param {File} data
   * @return {Promise<File>} 返回压缩后的 File
   */
  ;
export const compressImage = async (data) => {
  try {
    /** @type {Blob} */
    const blobFile = await imageCompression(data, {
      maxSizeMB: 0.6,
      maxWidthOrHeight: 1080,
      useWebWorker: true,
    });

    return new File([blobFile], data.name, { type: data.type });
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
}
/**
   * 银行卡脱敏并四位空格分段
   * @param {String|Number} cardNo 完整的银行卡号
   * @returns {String} 格式化后的字符串 (如: 2312 **** **** 8765)
   */
export const formatBankNumCard = (cardNo) => {
  if (!cardNo) return '';

  // 1. 转为字符串并去除所有空格
  const str = String(cardNo).replace(/\s/g, '');

  // 2. 健壮性判断：如果卡号过短（少于8位），无法满足前后保留4位，则只做4位空格分段
  if (str.length < 8) {
    return str.replace(/(.{4})/g, '$1 ').trim();
  }

  // 3. 提取前4位和后4位
  const first4 = str.substring(0, 4);
  const last4 = str.substring(str.length - 4);

  // 4. 计算中间需要被遮蔽的位数（现代银行卡一般为16位或19位）
  const maskLength = str.length - 8;

  // 5. 生成对应数量的 * 号，并以4位一组加上空格
  // 先拼接好未分段的完整遮蔽字符串：2312************8765
  const fullMaskStr = first4 + '*'.repeat(maskLength) + last4;

  // 6. 核心：每隔 4 位插入一个空格，并去除末尾可能多余的空格
  return fullMaskStr.replace(/(.{4})/g, '$1 ').trim();
}

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // 匹配常见的移动端设备关键词
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

  // 额外增加触摸点检测（兼容现代平板或触屏轻薄本）
  const isTouchDevice = ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 1);

  return mobileRegex.test(userAgent) || (isTouchDevice && window.screen.width <= 1024);
}
/**
 * 校验银行卡号是否合规（位数、纯数字及 Luhn 算法）
 * @param {string} cardNo 传入的银行卡号字符串
 * @returns {boolean} 校验结果，true 为通过，false 为不通过
 */
export function validateBankCard(cardNo) {
  if(!cardNo){
    return true;
  }
  // 1. 去除用户可能输入的空格
  const cleanedCardNo = cardNo.replace(/\s+/g, '');

  // 2. 校验位数（中国大陆境内银行卡通常为 15-19 位）以及是否为纯数字
  const reg = /^\d{15,19}$/;
  if (!reg.test(cleanedCardNo)) {
    return false;
  }

  // 3. Luhn 算法（模 10 校验）
  let sum = 0;
  let shouldDouble = false;

  // 从右向左（逆序）循环每一位数字
  for (let i = cleanedCardNo.length - 1; i >= 0; i--) {
    let digit = parseInt(cleanedCardNo.charAt(i), 10);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9; // 等同于加上个位数和十位数（例如 14 -> 1+4=5，即 14-9=5）
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble; // 隔位翻倍
  }

  // 如果总和能被 10 整除，则算法校验通过
  return (sum % 10 === 0);
}



